module.exports = __webpack_public_path__ + "8964f5930c645afebdbaf2fbf6a91ea1.svg";